const state = {
  widgets: {
    agent: false,
    contact: false,
    mobileMenu: false,
    scrollOffset: 0,
    lightbox: {
      show: false,
      photoIndex: 0
    },
    notification: {
      show: false,
      type: 'success',
      message: ''
    },
    lazyloaded: {
      slideshow: false
    }
  },
  fullStickyBg: {
    isPlay: false
  }
}

const mutations = {
  setVisibleAgent (state, visible) {
    state.widgets.agent = visible
  },
  setVisibleContact (state, visible) {
    state.widgets.contact = visible
  },
  setVisibleMobileMenu (state, visible) {
    state.widgets.mobileMenu = visible
  },
  setLazyloaded (state, name) {
    state.widgets.lazyloaded[name] = true
  },
  openLightbox (state, index) {
    state.widgets.lightbox = {
      show: true,
      photoIndex: index
    }
  },
  closeLightbox (state) {
    state.widgets.lightbox.show = false
  },
  openNotification (state, {type, message}) {
    state.widgets.notification = {
      show: true,
      type,
      message
    }
  },
  closeNotification (state) {
    state.widgets.notification.show = false
  },
  setScrollOffset (state, value) {
    state.widgets.scrollOffset = value
  },
  setIsPlay (state, value) {
    state.fullStickyBg.isPlay = value
  }
}

const actions = {
  setVisibleAgent ({commit}, visible) {
    commit('setVisibleAgent', visible)
  },
  setVisibleContact ({commit}, visible) {
    commit('setVisibleContact', visible)
  },
  setVisibleMobileMenu ({commit}, visible) {
    commit('setVisibleMobileMenu', visible)
  },
  setLazyloaded ({commit}, name) {
    commit('setLazyloaded', name)
  },
  openLightbox ({commit}, index) {
    commit('openLightbox', index)
  },
  closeLightbox ({commit}) {
    commit('closeLightbox')
  },
  openNotification ({commit}, payload) {
    commit('openNotification', payload)
  },
  closeNotification ({commit}) {
    commit('closeNotification')
  },
  setScrollOffset ({commit}, value) {
    commit('setScrollOffset', value)
  },
  setIsPlay ({commit}, value) {
    commit('setIsPlay', value)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
